import { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Loader from "../components/Loader/Loader.jsx";
import { initialCurrentUser } from "../features/auth/auth-slice.js";
import { BuscarMenu } from "../features/menu/menu-slice.js";
import config from "../config/config.js";

const LayoutPrivadas = lazy(() => import("../layouts/LayoutPrivadas"));
const Login = lazy(() => import("../pages/Login/Login.jsx"));
const RestorePassword = lazy(() => import("../pages/Login/components/RestorePassword.jsx"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound.jsx"));
const TurnoRechazado = lazy(() => import("../pages/TurnoRechazado/TurnoRechazado.jsx"));

const RegistrarseAco = lazy(() => import("../pages/RegistrarseAco/RegistrarseAco.jsx"));
const HOME_URL = 'WelcomePage'
const PATH_HOME_URL = `/${HOME_URL}`

// Rutas Generales para usuarios logueados
const routesGeneralLogged = [
  { path: "usuario/mis_datos", component: lazy(() => import("../pages/Usuario/MisDatos/MisDatos.jsx")) },
  { path: "login/reestablecerClave", component: lazy(() => import("../pages/ReestablecerClave/ReestablecerClave.jsx")) },
  { path: "turnos/MisNotificaciones", component: lazy(() => import("../pages/Notificaciones/Notificaciones.jsx")) },
  { path: "Reporte_TurnosViaje/Index", component: lazy(() => import("../pages/Reportes/TurnosAnticipados/TurnosAnticipados.jsx")) },
  { path: "Reporte_InformeCumplimiento/Index", component: lazy(() => import("../pages/Reportes/InformeCumplimiento/InformeCumplimiento.jsx")) },
  { path: HOME_URL, component: lazy(() => import("../pages/WelcomePage/WelcomePage.jsx")) },
];

// Rutas de Configuración y Secciones (Sujetas a validUrls)
const routesConfig = [
  // SECCION TURNOS
  { path: "InfoTerminalesDashboard/Index", component: lazy(() => import("../pages/Turnos/Dashboard/Dashboard.jsx")) },
  { path: "TurnosEnViajeMap/Index", component: lazy(() => import("../pages/Turnos/MapaTurnosEnViaje/MapaTurnosEnViaje.jsx")) },
  { path: "CuposConsultaSingle/Index", component: lazy(() => import("../pages/Turnos/TurnoConsultaSimple/TurnoConsultaSimple.jsx")) },
  { path: "TurnosBorrados/Index", component: lazy(() => import("../pages/Turnos/TurnosBorrados/TurnosBorrados.jsx")) },
  { path: "CTG_SinTurno/Index", component: lazy(() => import("../pages/Turnos/CtgSinTurno/CtgSinTurno.jsx")) },
  { path: "LogConsultaSimple/Index", component: lazy(() => import("../pages/Turnos/LogConsultasSimples/LogConsultasSimples.jsx")) },
  { path: "Calendario/Index", component: lazy(() => import("../pages/Turnos/Calendario/Calendario.jsx")) },
  { path: "CuposInterno/Index", component: lazy(() => import("../pages/Turnos/TurnosPlus/TurnosPlus.jsx")) },
  { path: "CuposInternoV2/Index", component: lazy(() => import("../pages/Turnos/Planifica/Planifica.jsx")) },
  { path: "DashboardBH/Index", component: lazy(() => import("../pages/Turnos/DashboardBH/DashboardBH.jsx")) },

  // SECCION E-VENTANILLA
  { path: "E_Ventanilla_Dashboard/Index", component: lazy(() => import("../pages/EVentanilla/Dashboard/Dashboard.jsx")) },

  // SECCION REPORTES
  { path: "Reporte_UsoMetodosPorKey/Index", component: lazy(() => import("../pages/Reportes/UsoMetodosPorKey/UsoMetodosPorKey.jsx")) },
  { path: "Reporte_PrevCumpl/Index", component: lazy(() => import("../pages/Reportes/PrevisibilidadyCumplimiento/PrevisibilidadyCumplimiento.jsx")) },
  { path: "Reporte_TurnosEmitidos/Index", component: lazy(() => import("../pages/Reportes/TurnosEmitidos/TurnosEmitidos.jsx")) },
  { path: "Reporte_CapacidadVsTurnos/Index", component: lazy(() => import("../pages/Reportes/CumplimientoUltimoMes/CumplimientoUltimoMes.jsx")) },
  { path: "Reporte_EstadisticasGenerales/Index", component: lazy(() => import("../pages/Reportes/EstadisticasGenerales/EstadisticasGenerales.jsx")) },
  { path: "Reporte_BolsaComercioRosario/Index", component: lazy(() => import("../pages/Reportes/BolsaComercioRosario/BolsaComercioRosario.jsx")) },

  // SECCION MANUALES
  { path: "maquetacion-componentes", component: lazy(() => import("../pages/MaquetacionComponentes/MaquetacionComponentes.jsx")) },
  { path: "Manuales/Index", component: lazy(() => import("../pages/Manuales/Manuales.jsx")) },

  // SECCION CONSULTAS PUBLICAS
  { path: "Home", component: lazy(() => import("../pages/ConsultasPublicas/Mapas/Mapas.jsx")) },
  { path: "InfoTerminales/Index", component: lazy(() => import("../pages/ConsultasPublicas/InfoTerminales/InfoTerminales.jsx")) },
  { path: "InfoLogisticaPlayas/Index", component: lazy(() => import("../pages/ConsultasPublicas/InfoLogisticaPlayas/InfoLogisticaPlayas.jsx")) },
  { path: "EstadoTerminales/VerEstadosTerminales", component: lazy(() => import("../pages/ConsultasPublicas/EstadoTerminales/EstadoTerminales.jsx")) },
  { path: "AsignacionTurnos/Index", component: lazy(() => import("../pages/ConsultasPublicas/AsignacionTurno/AsignacionTurno.jsx")) },

  // SECCION CONFIGURACIONES
  { path: "Usuario/Index", component: lazy(() => import("../pages/Configuracion/Usuarios/Usuarios.jsx")) },
  { path: "Notificacion/Index", component: lazy(() => import("../pages/Configuracion/Notificaciones/Notificaciones.jsx")) },
  { path: "EstadoTerminales/Index", component: lazy(() => import("../pages/Configuracion/EstadoTerminales/EstadoTerminales.jsx")) },
  { path: "AccesoKey/Index", component: lazy(() => import("../pages/Configuracion/ClaveAccesos/ClaveAccesos.jsx")) },
  { path: "Metodos/Index", component: lazy(() => import("../pages/Configuracion/MetodosAccesos/MetodosAccesos.jsx")) },
  { path: "Cuit/Index", component: lazy(() => import("../pages/Configuracion/Cuits/Cuits.jsx")) },
  { path: "Localidad/Index", component: lazy(() => import("../pages/Configuracion/LocalidadesSinGeolocalizacion/LocalidadesSinGeolocalizacion.jsx")) },
  { path: "Afip/Index", component: lazy(() => import("../pages/Configuracion/Afip/Afip.jsx")) },
  { path: "DesvioTerminales/Index", component: lazy(() => import("../pages/Configuracion/DesviosATerminales/DesviosATerminales.jsx")) },
  { path: "Terminal/Index", component: lazy(() => import("../pages/Configuracion/Terminales/Terminales.jsx")) },
  { path: "GrupoUsuarios/Index", component: lazy(() => import("../pages/Configuracion/GruposUsuarios/GruposUsuarios.jsx")) },
  { path: "Perfil/Index", component: lazy(() => import("../pages/Configuracion/Perfiles/Perfiles.jsx")) },
  { path: "Planta/Index", component: lazy(() => import("../pages/Configuracion/Plantas/Plantas.jsx")) },
  { path: "EstadoTerminalGrupUsr/Index", component: lazy(() => import("../pages/Configuracion/EstadoTerminalGrupoUsuarios/EstadoTerminalGrupoUsuarios.jsx")) },
  { path: "Archivo/Index", component: lazy(() => import("../pages/Configuracion/Archivos/Archivos.jsx")) },
  { path: "TurnoTerminal/Index", component: lazy(() => import("../pages/Configuracion/FranjasHorarias/FranjasHorarias.jsx")) },
  { path: "BandaHorariaV2/Index", component: lazy(() => import("../pages/Configuracion/BandasHorariasV2/BandasHorariasV2.jsx")) },
];

export default function Rutas() {
  const dispatch = useDispatch();
  const { validUrls, isLoading: isLoadingMenu } = useSelector((state) => state.menues);
  const { currentUser } = useSelector((state) => state.auth);

  // Estado local para controlar la hidratación inicial del usuario
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const getAndSetMenu = useCallback(
    async (user) => {
      try {
        if (user) {
          await dispatch(BuscarMenu());
        }
      } catch (err) {
        console.error("Error al traer los menues", err.message);
      }
    },
    [dispatch]
  );

  // Efecto único de inicialización
  useEffect(() => {
    const initApp = async () => {
      try {
        // Solo buscamos usuario si no está ya en el store
        if (!currentUser) {
          await dispatch(initialCurrentUser());
        }
      } catch (err) {
        console.error("Error en inicialización", err);
      } finally {
        // Marcamos que ya terminó de chequear el estado de sesión
        setIsCheckingAuth(false);
      }
    };
    initApp();
  }, [dispatch, currentUser]);

  // Efecto para cargar menú cuando cambia el usuario
  useEffect(() => {
    if (currentUser) {
      getAndSetMenu(currentUser);
    }
  }, [currentUser, getAndSetMenu]);

  // Mientras verificamos auth o cargamos menú crítico, mostramos Loader
  // Esto evita que el Router procese rutas antes de tiempo (causa de la pantalla blanca)
  if (isCheckingAuth || (currentUser && isLoadingMenu)) {
    return <Loader />;
  }

  return (
    <BrowserRouter basename={config.URL.STOP_APP_BASENAME}>
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Lógica de la Raíz: Redirige según estado de sesión */}
          <Route
            path="/"
            element={
              currentUser ? (
                <Navigate to="/InfoTerminalesDashboard/Index" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route
            path="/solicitud-registro"
            element={
              <RegistrarseAco />
            }
          />

          {/* Login: Si ya está logueado, lo saca de aquí para evitar loops */}
          <Route
            path="/login"
            element={
              currentUser ? <Navigate to={PATH_HOME_URL} replace /> : <Login PATH_HOME_URL={PATH_HOME_URL} />
            }
          />

          <Route path="/reset-password/:token" element={<RestorePassword />} />
          <Route path="/ConsultaXCTGRechazado/Id/:idTurno" element={<TurnoRechazado />} />

          {/* Grupo de Rutas Privadas envueltas por el Layout */}
          <Route
            element={
              currentUser ? (
                <LayoutPrivadas />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            {/* Mapeo de rutas generales */}
            {routesGeneralLogged.map(({ path, component: Component }) => (
              <Route
                key={path}
                path={path}
                element={<Component />}
              />
            ))}

            {/* Mapeo de rutas con permisos específicos */}
            {routesConfig.map(({ path, component: Component }) =>
              validUrls.includes(path) ? (
                <Route
                  key={path}
                  path={path}
                  element={<Component />}
                />
              ) : null
            )}
          </Route>

          {/* Catch-all para 404 */}
          <Route path="*" element={<NotFound PATH_HOME_URL={PATH_HOME_URL} />} />
        </Routes>
      </Suspense>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  );
}